import React, { useEffect, useRef } from "react";

interface IProps {
  children: React.ReactNode;
  isOpen: boolean;
  handleClose: () => void;
  classNames?: string;
  containerRef?: React.RefObject<HTMLDivElement>;
  handleFieldActive: (field: 'keywords' | 'location' | 'exp' | null) => void;
}

const DropdownWrapper: React.FC<IProps> = ({
  children,
  isOpen,
  handleClose,
  classNames,
  containerRef,
  handleFieldActive
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef) {
        if (
          containerRef.current &&
          !containerRef.current.contains(event.target as Node)
        ) {
          handleClose();
          handleFieldActive(null);
        }
        return;
      }
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        handleClose();
        handleFieldActive(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, handleClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={wrapperRef}
      className={`qs_dd_wrapper${classNames ? ` ${classNames}` : ""}`}
    >
      {children}
    </div>
  );
};

export default DropdownWrapper;
